import React, { useState } from 'react';

import { Button, primaryTheme } from '@repo/ui/components/Buttons';
import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { H3, P2 } from '@repo/ui/components/Typography';
import { Modal } from '@repo/ui/deprecated/Modal';

import userApi from 'global/userApi';
import { FlexRow } from 'styles/layouts';

import { Wrapper } from './styles';
import { buttonTheme } from './theme';

const ReportModal = ({ isOpen, onClose, type, referenceId }) => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleClose = () => {
    onClose && onClose();

    // wait for close animation to have finished
    setTimeout(() => {
      setIsSuccess(false);
    }, 1000);
  };

  const reportMessages = [
    { label: 'Copyright infringement', category: 'COPYRIGHT' },
    { label: 'Pornographic', category: 'PORNOGRAPHIC' },
    { label: 'Violence', category: 'VIOLENCE' },
    { label: 'Spam', category: 'SPAM' },
    { label: 'Hate speech', category: 'HATE_SPEECH' },
    { label: 'Other', category: 'OTHER' },
  ];

  const handleReport = async (category) => {
    const response = await userApi.createReport(type, category, referenceId);

    if (response.success) {
      setIsSuccess(true);
    }
  };

  if (isSuccess) {
    return (
      <Modal isOpen={isOpen} width="408px" onClose={handleClose}>
        <Wrapper style={{ textAlign: 'center' }}>
          <H3>Content reported</H3>
          <Spacer height="22px" />
          <P2>
            We will review the content within 24h.
            <br />
            Thanks for your help.
          </P2>
          <Spacer height="24px" />
          <FlexRow justifyContent="space-around">
            <Button
              height="40px"
              label="Close"
              theme={primaryTheme}
              width="110px"
              onClick={handleClose}
            />
          </FlexRow>
          <Spacer height="10px" />
        </Wrapper>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} width="486px" onClose={handleClose}>
      <Wrapper>
        <FlexRow gap="12px">
          <InfoThickIcon height="22px" />
          <H3>Report this content</H3>
        </FlexRow>
        <Spacer height="16px" />
        <P2>
          Please let us know why this content violates our community standards.
          Select an issue to report the content for review.
        </P2>
        <Spacer height="24px" />
        {reportMessages.map(({ label, category }, index) => (
          <React.Fragment key={category}>
            {index > 0 && <Spacer height="16px" />}
            <Button
              height="52px"
              label={label}
              theme={buttonTheme}
              width="100%"
              onClick={() => handleReport(category)}
            />
          </React.Fragment>
        ))}
      </Wrapper>
    </Modal>
  );
};

export default ReportModal;
